module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kNI7a"))).then(() => parcelRequire('d0iPb'));